'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _preludeExtension = require('prelude-extension');

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

var _venues = require('redux/modules/venues');

var venuesActions = _interopRequireWildcard(_venues);

var _rooms = require('redux/modules/rooms');

var roomsActions = _interopRequireWildcard(_rooms);

var _lodash = require('lodash.isempty');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _Creatable = require('react-select/lib/Creatable');

var _Creatable2 = _interopRequireDefault(_Creatable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _validate = require('../../helpers/validate');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allEventDatesHasSameVenue = function allEventDatesHasSameVenue() {
  var dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return dates.reduce(function (_ref, _ref2) {
    var allSame = _ref.allSame,
        lastVenueId = _ref.lastVenueId,
        lastRoomId = _ref.lastRoomId;
    var _ref2$venue = _ref2.venue,
        venue = _ref2$venue === undefined ? null : _ref2$venue,
        _ref2$room = _ref2.room,
        room = _ref2$room === undefined ? null : _ref2$room;
    return {
      allSame: allSame && (lastVenueId === null || venue === null || lastVenueId === venue.id) && (lastRoomId === null || room === null || lastRoomId === room.id),
      lastVenueId: venue !== null ? venue.id : lastVenueId,
      lastRoomId: room !== null ? room.id : lastRoomId
    };
  }, {
    allSame: true,
    lastVenueId: null,
    lastRoomId: null
  }).allSame;
};

var VenueBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return { venues: state.venues.venues };
}, (0, _extends4.default)({}, venuesActions, { saveRoom: roomsActions.save })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(VenueBox, _Component);

  function VenueBox() {
    var _ref3;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VenueBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = VenueBox.__proto__ || (0, _getPrototypeOf2.default)(VenueBox)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      ajax: null,
      createNewVenue: false,
      newVenueIndex: null,
      venue: {},
      venueByDates: !allEventDatesHasSameVenue(_this.props.dates),
      loaded: false,
      loading: false,
      loadingIndex: null,
      dates: _this.props.dates || [],
      venues: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VenueBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dates = this.props.dates;

      if (dates && dates.length > 0) {
        this.onDatesChanged(dates);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.dates !== this.props.dates) {
        var dates = nextProps.dates || [];

        this.setState({
          dates: nextProps.dates,
          venue: null,
          room: null
        }, function () {
          _this2.onDatesChanged(dates);
        });
      }
    }
  }, {
    key: 'onDatesChanged',
    value: function onDatesChanged(dates) {
      var _this3 = this;

      var venueIds = dates.map(function (d) {
        return d.venue && d.venue.id ? d.venue.id : null;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index && value !== null;
      });

      /* This is only to avoid the api throttle */
      venueIds.reduce(function (p, id) {
        return p.then(function () {
          return new _promise2.default(function (resolve) {
            _this3.loadRooms(id).then(function (room) {
              _this3.setState(function (_ref4) {
                var rooms = _ref4.rooms;
                return {
                  rooms: (0, _extends4.default)({}, rooms, room)
                };
              }, function () {
                resolve();
              });
            });
          });
        });
      }, _promise2.default.resolve());
    }
  }, {
    key: 'onSearchChange',
    value: function onSearchChange(input, index) {
      var _this4 = this;

      var query = input.trim();
      var ajax = this.state.ajax;


      if (ajax) {
        clearTimeout(ajax);
      }

      this.setState({
        ajax: setTimeout(function () {
          _this4.loadVenues(query);
        }, 250),
        loaded: false,
        loadingIndex: index
      });
    }
  }, {
    key: 'onRoomSearchChange',
    value: function onRoomSearchChange(input, index) {
      var query = input.trim();
      var dates = this.state.dates;

      var venue = (dates[index || 0] || {}).venue || null;
      var venueId = venue ? venue.id : null;
      var rooms = venue ? venue.rooms : [];
      // only render rooms when a venue has existing rooms
      if (rooms) {
        var roomsRendered = rooms.filter(function (room) {
          return room.name.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1;
        }).map(function (room) {
          var stringPartitions = (0, _preludeExtension.partitionString)((0, _unidecode2.default)(room.name).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase());
          var labelPartitions = stringPartitions.length === 0 ? [0, room.name.length, false] : stringPartitions;
          return (0, _extends4.default)({}, room, {
            label: room.name,
            value: room.id,
            id: room.id,
            labelPartitions: labelPartitions
          });
        });
        this.setState(function (prevState) {
          return {
            rooms: (0, _extends4.default)({}, prevState.rooms, (0, _defineProperty3.default)({}, venueId, roomsRendered)),
            loading: false
          };
        });
      }
    }
  }, {
    key: 'loadVenues',
    value: function loadVenues(query, callback) {
      var _this5 = this;

      var _props = this.props,
          search = _props.search,
          regions = _props.regions;

      if (query.length > 2) {
        this.setState({
          ajax: null,
          loading: true
        }, function () {
          search(query, regions).then(function (venues) {
            var venuesRendered = venues.result.data.map(function (venue) {
              var stringPartitions = (0, _preludeExtension.partitionString)((0, _unidecode2.default)(venue.name).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase());
              var labelPartitions = stringPartitions.length === 0 ? [0, venue.name.length, false] : stringPartitions;
              return (0, _extends4.default)({}, venue, {
                value: venue.id,
                label: venue.name,
                labelPartitions: labelPartitions
              });
            });
            _this5.setState({
              loaded: !_this5.state.ajax,
              loading: false,
              venues: venuesRendered
            }, callback);
          });
        });
      } else if (query.length <= 2) {
        this.setState({
          venues: [],
          loading: false
        }, callback);
      }
    }
  }, {
    key: 'focusFirstInput',
    value: function focusFirstInput() {
      document.getElementById('venue_address').focus();
    }
  }, {
    key: 'loadRooms',
    value: function loadRooms(venueId) {
      return this.props.getVenue(venueId).then(function (venue) {
        /* eslint-disable indent */
        var roomsRendered = Array.isArray(venue.result.rooms) ? venue.result.rooms.map(function (room) {
          return {
            id: room.id,
            value: room.id,
            label: room.name,
            labelPartitions: [0, room.name.length, false]
          };
        }) : [];
        return (0, _defineProperty3.default)({}, venueId, roomsRendered);
        /* eslint-enable indent */
      });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.refs.venueBoxOverlayTrigger.hide();
    }
  }, {
    key: 'handleClickApplyToEmptyDates',
    value: function handleClickApplyToEmptyDates(venue, room) {
      this.setState(function (_ref6) {
        var dates = _ref6.dates;
        return {
          dates: dates.map(function (date) {
            var _date$venue = date.venue,
                dateVenue = _date$venue === undefined ? null : _date$venue,
                _date$room = date.room,
                roomVenue = _date$room === undefined ? null : _date$room,
                otherDate = (0, _objectWithoutProperties3.default)(date, ['venue', 'room']);
            /* eslint-disable indent */

            return dateVenue === null ? (0, _extends4.default)({}, otherDate, {
              venue: venue,
              room: room
            }) : date;
            /* eslint-enable indent */
          })
        };
      });
    }
  }, {
    key: 'handleVenueByDatesChange',
    value: function handleVenueByDatesChange(e) {
      var newVenueByDates = e.currentTarget.checked;
      this.setState(function (_ref7) {
        var venueByDates = _ref7.venueByDates,
            dates = _ref7.dates;

        var _dates$reduce = dates.reduce(function (_ref8, _ref9) {
          var foundVenue = _ref8.venue,
              foundRoom = _ref8.room;
          var _ref9$venue = _ref9.venue,
              venue = _ref9$venue === undefined ? null : _ref9$venue,
              _ref9$room = _ref9.room,
              room = _ref9$room === undefined ? null : _ref9$room;
          return {
            venue: foundVenue === null && venue !== null ? venue : foundVenue,
            room: foundVenue === null && venue !== null ? room : foundRoom
          };
        }, {
          venue: null,
          room: null
        }),
            _dates$reduce$venue = _dates$reduce.venue,
            firstVenue = _dates$reduce$venue === undefined ? null : _dates$reduce$venue,
            _dates$reduce$room = _dates$reduce.room,
            firstRoom = _dates$reduce$room === undefined ? null : _dates$reduce$room;

        return {
          venueByDates: newVenueByDates,
          /* eslint-disable indent */
          dates: !newVenueByDates && venueByDates ? dates.map(function (it) {
            return (0, _extends4.default)({}, it, {
              venue: firstVenue,
              room: firstRoom
            });
          }) : dates
          /* eslint-enable indent */
        };
      });
    }
  }, {
    key: 'returnToSearch',
    value: function returnToSearch() {
      this.setState({
        createNewVenue: false,
        venue: this.props.venue
      });
    }
  }, {
    key: 'handleRoomChange',
    value: function handleRoomChange(room, index) {
      if (room && room.__isNew__) {
        this.createRoom(room, index);
      } else if (room && !room.__isNew__) {
        this.updateRoom(room, index);
      } else {
        this.setState(function (_ref10) {
          var dates = _ref10.dates;
          return {
            dates: dates.map(function (it, itIndex) {
              return index === null || itIndex === index ? (0, _extends4.default)({}, it, {
                room: null
              }) : it;
            })
          };
        });
      }
    }
  }, {
    key: 'createRoom',
    value: function createRoom(room, index) {
      var _this6 = this;

      var saveRoom = this.props.saveRoom;
      var dates = this.state.dates;

      var date = index && dates[index] ? dates[index] : dates[0];

      if (room && date && date.venue) {
        saveRoom((0, _extends4.default)({}, room, { name: room.value, venue_id: date.venue.id })).then(function (res) {
          if (res && res.type === roomsActions.SAVE_SUCCESS) {
            _this6.setState({
              room: {},
              /* eslint-disable indent */
              dates: dates.map(function (it, itIndex) {
                return itIndex === index || dates.length === 1 ? (0, _extends4.default)({}, it, {
                  room: res.result
                }) : it;
              })
              /* eslint-enable indent */
            });
            _this6.props.onChange(_this6.state.dates, { room: room });
          }
        });
      } else {
        this.props.onChange(this.state.dates, { room: room });
      }
    }
  }, {
    key: 'updateRoom',
    value: function updateRoom(room) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setState(
      /* eslint-disable indent */
      function (_ref11) {
        var dates = _ref11.dates;
        return {
          dates: dates.map(function (it, itIndex) {
            return index === null || itIndex === index ? (0, _extends4.default)({}, it, {
              room: room
            }) : it;
          })
        };
      }
      /* eslint-enable indent */
      );
    }
  }, {
    key: 'handleVenueChange',
    value: function handleVenueChange(venue, index) {
      if (venue && venue.__isNew__) {
        this.createVenue(venue, index);
      } else if (venue && !venue.__isNew__) {
        this.updateVenue(venue, index);
      } else {
        this.setState(function (_ref12) {
          var dates = _ref12.dates;
          return {
            dates: dates.map(function (it, itIndex) {
              return index === null || itIndex === index ? (0, _extends4.default)({}, it, {
                venue: null,
                room: null
              }) : it;
            })
          };
        });
      }
    }
  }, {
    key: 'createVenue',
    value: function createVenue(venue, index) {
      var _this7 = this;

      this.setState({
        venue: (0, _extends4.default)({}, venue, { name: venue.value })
      }, function () {
        _this7.setState({
          createNewVenue: true,
          newVenueIndex: index
        }, function () {
          // this.focusFirstInput();
        });
      });
      return null;
    }
  }, {
    key: 'updateVenue',
    value: function updateVenue(venue) {
      var _this8 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setState(
      /* eslint-disable indent */
      function (_ref13) {
        var dates = _ref13.dates;
        return {
          dates: dates.map(function (it, itIndex) {
            return index === null || itIndex === index ? (0, _extends4.default)({}, it, {
              venue: venue
            }) : it;
          })
        };
      },
      /* eslint-enable indent */
      function () {
        var dates = _this8.state.dates;

        _this8.loadRooms(venue.value).then(function (room) {
          return _this8.setState(function (_ref14) {
            var rooms = _ref14.rooms;
            return { rooms: (0, _extends4.default)({}, rooms, room) };
          });
        });
        _this8.props.onChange(dates, { venue: venue });
      });
    }
  }, {
    key: 'changeName',
    value: function changeName(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { name: event.target.value } })
      });
    }
  }, {
    key: 'changeAddress',
    value: function changeAddress(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { address: event.target.value } })
      });
    }
  }, {
    key: 'changeAddress2',
    value: function changeAddress2(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { address2: event.target.value } })
      });
    }
  }, {
    key: 'changeCity',
    value: function changeCity(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { city: event.target.value } })
      });
    }
  }, {
    key: 'changePostalCode',
    value: function changePostalCode(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { zip: event.target.value } })
      });
    }
  }, {
    key: 'changePhone',
    value: function changePhone(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { phone: event.target.value } })
      });
    }
  }, {
    key: 'changeRegion',
    value: function changeRegion(region) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: {
            region: { id: region.value, name: region.label },
            region_id: region.value
          } })
      });
    }
  }, {
    key: 'changeWebsite',
    value: function changeWebsite(event) {
      this.setState({
        venue: (0, _reactAddonsUpdate2.default)(this.state.venue, { $merge: { website_url: event.target.value } })
      });
    }
  }, {
    key: 'saveVenue',
    value: function saveVenue() {
      var _this9 = this;

      var save = this.props.save;
      var _state = this.state,
          venue = _state.venue,
          newVenueIndex = _state.newVenueIndex,
          dates = _state.dates;

      // Save it to the back-end the first time

      if (venue && venue.__isNew__) {
        save(venue).then(function (res) {
          if (res && res.type === venuesActions.SAVE_SUCCESS) {
            _this9.setState({
              venue: {},
              createNewVenue: false,
              newVenueIndex: null,
              /* eslint-disable indent */
              dates: dates.map(function (it, itIndex) {
                return itIndex === newVenueIndex || dates.length === 1 ? (0, _extends4.default)({}, it, {
                  venue: res.result
                }) : it;
              })
              /* eslint-enable indent */
            });
            _this9.props.onChange(_this9.state.dates, { venue: res.result });
            _this9.refs.venueBoxOverlayTrigger.hide();
          }
        });
      } else {
        this.props.onChange(this.state.dates);
        this.refs.venueBoxOverlayTrigger.hide();
      }
    }
  }, {
    key: 'renderNoResults',
    value: function renderNoResults(value) {
      var polyglot = this.props.polyglot;
      var loading = this.state.loading;


      if (loading) {
        return _react2.default.createElement(
          'div',
          { className: 'no-results-found', style: { fontSize: 13 } },
          value.length <= 2 ? polyglot.t('events.venueBox.typeSome') : polyglot.t('events.loading')
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'no-results-found', style: { fontSize: 13 } },
        value.length <= 2 ? polyglot.t('events.venueBox.typeSome') : polyglot.t('events.venueBox.noResults')
      );
    }
  }, {
    key: 'renderVenueSelect',
    value: function renderVenueSelect() {
      var _this10 = this;

      var venue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _state2 = this.state,
          loaded = _state2.loaded,
          venues = _state2.venues,
          loading = _state2.loading,
          loadingIndex = _state2.loadingIndex;
      var polyglot = this.props.polyglot;

      return _react2.default.createElement(_Creatable2.default, {
        allowCreateWhileLoading: false,
        autoFocus: true,
        className: 'venue-box-venue-select',
        classNamePrefix: 'react-select',
        filterOption: function filterOption(opts) {
          return opts;
        },
        formatCreateLabel: function formatCreateLabel(label) {
          return polyglot.t('events.venueBox.createVenue') + ' ' + label + '... ';
        },
        isClearable: true,
        isLoading: loadingIndex === index && loading,
        isValidNewOption: function isValidNewOption(val) {
          return val.length > 2 && loaded && !venues.find(function (v) {
            return v.label === val;
          });
        },
        loadingMessage: function loadingMessage() {
          return polyglot.t('events.loading');
        },
        noOptionsMessage: this.renderNoResults.bind(this),
        onChange: function onChange(val) {
          return _this10.handleVenueChange(val, index);
        },
        onInputChange: function onInputChange(input) {
          return _this10.onSearchChange(input, index);
        },
        options: venues,
        placeholder: polyglot.t('events.venueBox.searchOrAddVenue'),
        value: venue !== null ? (0, _extends4.default)({ label: venue.name, value: venue.id }, venue) : null
      });
    }
  }, {
    key: 'renderRoomSelect',
    value: function renderRoomSelect() {
      var _this11 = this,
          _React$createElement;

      var room = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _state3 = this.state,
          _state3$rooms = _state3.rooms,
          rooms = _state3$rooms === undefined ? {} : _state3$rooms,
          _state3$dates = _state3.dates,
          dates = _state3$dates === undefined ? [] : _state3$dates;
      var polyglot = this.props.polyglot;

      var venue = (dates[index || 0] || {}).venue || null;
      var currentRooms = venue !== null ? rooms[venue.id] : [];
      return _react2.default.createElement(_Creatable2.default, (_React$createElement = {
        className: 'react-select'
      }, (0, _defineProperty3.default)(_React$createElement, 'className', 'venue-box-room-select'), (0, _defineProperty3.default)(_React$createElement, 'classNamePrefix', 'react-select'), (0, _defineProperty3.default)(_React$createElement, 'formatCreateLabel', function formatCreateLabel(label) {
        return polyglot.t('events.venueBox.createRoom') + ' ' + label + '... ';
      }), (0, _defineProperty3.default)(_React$createElement, 'isClearable', true), (0, _defineProperty3.default)(_React$createElement, 'noOptionsMessage', this.renderNoResults.bind(this)), (0, _defineProperty3.default)(_React$createElement, 'onChange', function onChange(val) {
        return _this11.handleRoomChange(val, index);
      }), (0, _defineProperty3.default)(_React$createElement, 'onInputChange', function onInputChange(input) {
        return _this11.onRoomSearchChange(input, index);
      }), (0, _defineProperty3.default)(_React$createElement, 'options', currentRooms), (0, _defineProperty3.default)(_React$createElement, 'placeholder', polyglot.t('events.venueBox.rooms')), (0, _defineProperty3.default)(_React$createElement, 'value', room !== null ? (0, _extends4.default)({ label: room.name, value: room.id }, room) : null), _React$createElement));
    }
  }, {
    key: 'renderDates',
    value: function renderDates() {
      var _this12 = this;

      var polyglot = this.props.polyglot;
      var _state4 = this.state,
          venueByDates = _state4.venueByDates,
          dates = _state4.dates;

      var checkboxByDates = this.renderCheckBoxByDates();
      var actions = this.renderActions();

      var hasEmptyDates = venueByDates && dates.reduce(function (hasEmpty, _ref15) {
        var _ref15$venue = _ref15.venue,
            dateVenue = _ref15$venue === undefined ? null : _ref15$venue;
        return hasEmpty || dateVenue === null;
      }, false);

      return _react2.default.createElement(
        _reactBootstrap.Popover,
        {
          id: 'venueBoxPopoverByDates',
          className: (0, _classnames2.default)(['venue-box-popover', 'by-dates'])
        },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'div',
            null,
            checkboxByDates,
            _react2.default.createElement(
              'div',
              { className: 'venue-box-dates-list-container' },
              _react2.default.createElement(
                'div',
                { className: 'venue-box-dates-list' },
                dates.map(function (_ref16, index) {
                  var startDate = _ref16.start_date,
                      duration = _ref16.duration,
                      _ref16$venue = _ref16.venue,
                      dateVenue = _ref16$venue === undefined ? null : _ref16$venue,
                      _ref16$room = _ref16.room,
                      dateRoom = _ref16$room === undefined ? null : _ref16$room;

                  var startDateMoment = (0, _moment2.default)(startDate);
                  return _react2.default.createElement(
                    'div',
                    { key: 'date-' + index, className: 'result venue-box-dates-list-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'dates-list-item-dates' },
                      _react2.default.createElement(
                        'strong',
                        null,
                        startDateMoment.format('LLLL')
                      ),
                      startDateMoment.format('HH:mm')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'dates-list-item-venue' },
                      _this12.renderVenueSelect(dateVenue, index)
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'dates-list-item-room' },
                      _this12.renderRoomSelect(dateRoom, index)
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'dates-list-item-actions' },
                      dateVenue !== null && hasEmptyDates ? _react2.default.createElement(
                        'a',
                        {
                          href: '#',
                          onClick: function onClick() {
                            return _this12.handleClickApplyToEmptyDates(dateVenue, dateRoom);
                          }
                        },
                        polyglot.t('events.venueBox.applyToEmptyDates')
                      ) : null
                    )
                  );
                })
              )
            ),
            actions
          )
        )
      );
    }
  }, {
    key: 'renderDate',
    value: function renderDate(venue, room) {
      var polyglot = this.props.polyglot;

      var checkboxByDates = this.renderCheckBoxByDates();
      var actions = this.renderActions();
      return _react2.default.createElement(
        'div',
        null,
        checkboxByDates,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.venueBox.searchOrAddVenue')
          ),
          _react2.default.createElement(
            'div',
            { className: 'venue-box-select-container' },
            this.renderVenueSelect(venue)
          ),
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.venueBox.room'),
            ' ',
            _react2.default.createElement(
              'span',
              { className: 'optional' },
              polyglot.t('events.venueBox.optional')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'venue-box-select-container' },
            this.renderRoomSelect(room)
          )
        ),
        actions
      );
    }
  }, {
    key: 'renderNewVenue',
    value: function renderNewVenue(venue) {
      var _props2 = this.props,
          polyglot = _props2.polyglot,
          regions = _props2.regions;

      return _react2.default.createElement(VenueBox.NewVenueForm, {
        changeAddress2: this.changeAddress2.bind(this),
        changeAddress: this.changeAddress.bind(this),
        changeCity: this.changeCity.bind(this),
        changeName: this.changeName.bind(this),
        changePhone: this.changePhone.bind(this),
        changePostalCode: this.changePostalCode.bind(this),
        changeRegion: this.changeRegion.bind(this),
        changeWebsite: this.changeWebsite.bind(this),
        polyglot: polyglot,
        returnToSearch: this.returnToSearch.bind(this),
        saveVenue: this.saveVenue.bind(this),
        venue: venue,
        regions: regions
      });
    }
  }, {
    key: 'renderCheckBoxByDates',
    value: function renderCheckBoxByDates() {
      var _props3 = this.props,
          allowMultipleVenues = _props3.allowMultipleVenues,
          polyglot = _props3.polyglot;
      var _state5 = this.state,
          venueByDates = _state5.venueByDates,
          dates = _state5.dates;


      return dates.length > 1 && allowMultipleVenues ? _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
          'label',
          { className: 'control-label' },
          _react2.default.createElement('input', {
            type: 'checkbox',
            onChange: this.handleVenueByDatesChange.bind(this),
            checked: venueByDates
          }),
          '\xA0',
          polyglot.t('events.venueBox.venueByDates')
        )
      ) : null;
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      var polyglot = this.props.polyglot;

      return _react2.default.createElement(
        'div',
        { className: 'popover-actions' },
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-default btn-outline',
              onClick: this.handleCancel.bind(this)
            },
            polyglot.t('button.cancel')
          ),
          '\xA0',
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary', onClick: this.saveVenue.bind(this) },
            'OK'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          popoverContainer = _props4.popoverContainer,
          errors = _props4.errors,
          polyglot = _props4.polyglot,
          defaultVenue = _props4.defaultVenue,
          defaultRoom = _props4.defaultRoom;
      var _state6 = this.state,
          createNewVenue = _state6.createNewVenue,
          venueByDates = _state6.venueByDates,
          dates = _state6.dates;

      var room = dates.length > 0 ? dates[0].room : defaultRoom;
      var venue = void 0;

      if (createNewVenue) {
        venue = this.state.venue;
      } else {
        venue = dates.length > 0 ? dates[0].venue : defaultVenue;
      }

      var boxDetail = '';
      if ((0, _lodash2.default)(venue)) {
        boxDetail = _react2.default.createElement(VenueBox.EmptyVenue, { errors: errors });
      } else {
        boxDetail = _react2.default.createElement(VenueBox.HasVenue, {
          polyglot: polyglot,
          venue: venue,
          room: room,
          byDates: venueByDates,
          errors: errors
        });
      }

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'venueBoxOverlayTrigger',
          trigger: ['click', 'focus'],
          delayShow: 200,
          placement: 'bottom',
          rootClose: true,
          container: popoverContainer,
          shouldUpdatePosition: true,
          overlay: venueByDates && !createNewVenue ? this.renderDates() : _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'venueBoxPopover', className: 'venue-box-popover' },
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              createNewVenue ? this.renderNewVenue(venue) : this.renderDate(venue, room)
            )
          )
        },
        boxDetail
      );
    }
  }], [{
    key: 'EmptyVenue',
    value: function EmptyVenue(_ref17) {
      var onClick = _ref17.onClick,
          errors = _ref17.errors;

      return _react2.default.createElement(
        'div',
        {
          className: 'venue-box empty dashed-box event-venue-box' + (errors.length > 0 ? ' has-error' : ''),
          tabIndex: '-1',
          onClick: onClick
        },
        _react2.default.createElement('span', { className: 'icon-cg-pin' }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { className: 'dashed-box-bottom-text' },
          _react2.default.createElement(
            'label',
            null,
            'Lieu'
          ),
          _react2.default.createElement(
            'span',
            { className: 'label label-danger label-required' },
            'Requis'
          )
        )
      );
    }
  }, {
    key: 'HasVenue',
    value: function HasVenue(_ref18) {
      var polyglot = _ref18.polyglot,
          onClick = _ref18.onClick,
          venue = _ref18.venue,
          room = _ref18.room,
          _ref18$byDates = _ref18.byDates,
          byDates = _ref18$byDates === undefined ? false : _ref18$byDates,
          errors = _ref18.errors;

      var lines = [!(0, _lodash2.default)(venue.name) ? _react2.default.createElement(
        'strong',
        { key: 'venue-' + venue.name },
        venue.name
      ) : null, [venue.address, venue.address2].filter(function (it) {
        return !(0, _lodash2.default)(it);
      }).join(' '), [venue.city, venue.state ? '(' + venue.state + ')' : '', venue.country].filter(function (it) {
        return !(0, _lodash2.default)(it);
      }).join(' ')].filter(function (it) {
        return !(0, _lodash2.default)(it);
      }).reduce(function (allLines, line) {
        return [].concat((0, _toConsumableArray3.default)(allLines), [line, _react2.default.createElement('br', { key: 'br-' + line })]);
      }, []);
      return _react2.default.createElement(
        'div',
        {
          className: 'venue-box has-venue line-box event-venue-box' + (errors.length > 0 ? ' has-error' : ''),
          tabIndex: '-1',
          onClick: onClick
        },
        lines,
        _react2.default.createElement(
          'b',
          null,
          room ? room.name : ''
        ),
        byDates ? _react2.default.createElement(
          'strong',
          { className: 'info-text other-venues' },
          _react2.default.createElement('span', { className: 'icon-cg-multiple' }),
          polyglot.t('events.venueBox.otherVenuesByDates')
        ) : null
      );
    }
  }, {
    key: 'NewVenueForm',
    value: function NewVenueForm(_ref19) {
      var venue = _ref19.venue,
          regions = _ref19.regions,
          polyglot = _ref19.polyglot,
          returnToSearch = _ref19.returnToSearch,
          changeName = _ref19.changeName,
          changeAddress = _ref19.changeAddress,
          changeAddress2 = _ref19.changeAddress2,
          changeCity = _ref19.changeCity,
          changePostalCode = _ref19.changePostalCode,
          changePhone = _ref19.changePhone,
          changeRegion = _ref19.changeRegion,
          changeWebsite = _ref19.changeWebsite,
          saveVenue = _ref19.saveVenue;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { onClick: returnToSearch, className: 'back-link', href: '#' },
          _react2.default.createElement('span', { className: 'icon-cg-chevron-left' }),
          ' ',
          polyglot.t('events.venueBox.backToSearch')
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.venueBox.name')
          ),
          _react2.default.createElement('input', {
            type: 'text',
            className: 'form-control',
            name: 'venue-name',
            defaultValue: venue.value,
            onChange: changeName
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.venueBox.address')
          ),
          _react2.default.createElement('input', {
            type: 'text',
            id: 'venue_address',
            className: 'form-control',
            name: 'venue-address',
            defaultValue: venue.address,
            onChange: changeAddress
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement('input', {
            type: 'text',
            className: 'form-control',
            name: 'venue-address2',
            defaultValue: venue.address2,
            onChange: changeAddress2
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'form-group col-sm-6' },
            _react2.default.createElement(
              'label',
              null,
              polyglot.t('events.venueBox.city')
            ),
            _react2.default.createElement('input', {
              type: 'text',
              className: 'form-control',
              name: 'venue-city',
              defaultValue: venue.city,
              onChange: changeCity
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group col-sm-6' },
            _react2.default.createElement(
              'label',
              null,
              polyglot.t('events.venueBox.postalCode')
            ),
            _react2.default.createElement('input', {
              type: 'text',
              className: 'form-control',
              name: 'venue-postal-code',
              defaultValue: venue.zip,
              onChange: changePostalCode
            })
          )
        ),
        regions.length > 0 && _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.venueBox.region')
          ),
          _react2.default.createElement(_reactSelect2.default, {
            className: 'react-select',
            classNamePrefix: 'react-select',
            options: regions.map(function (r) {
              return { label: r.name, value: r.id };
            }),
            value: venue.region ? { label: venue.region.name, value: venue.region.id } : {},
            onChange: changeRegion,
            placeholder: polyglot.t('events.venueBox.chooseRegion')
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            null,
            polyglot.t('events.venueBox.phone')
          ),
          _react2.default.createElement('input', {
            type: 'text',
            className: 'form-control',
            name: 'venue-phone',
            defaultValue: venue.phone,
            onChange: changePhone
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.FormGroup,
          {
            controlId: 'venue_website',
            validationState: (0, _validate.validate)('urlOrEmpty', venue.website_url, [])
          },
          _react2.default.createElement(
            _reactBootstrap.ControlLabel,
            null,
            polyglot.t('events.venueBox.website')
          ),
          _react2.default.createElement(_reactBootstrap.FormControl, {
            defaultValue: venue.website_url,
            onChange: changeWebsite,
            placeholder: 'https://'
          }),
          _react2.default.createElement(
            _reactBootstrap.HelpBlock,
            null,
            polyglot.t('events.venueBox.specifyProtocol')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 popover-actions' },
            _react2.default.createElement(
              'button',
              { type: 'button', onClick: saveVenue, className: 'btn btn-primary pull-right' },
              polyglot.t('events.venueBox.saveVenue')
            )
          )
        )
      );
    }
  }]);
  return VenueBox;
}(_react.Component), _class2.propTypes = {
  allowMultipleVenues: _propTypes2.default.bool,
  defaultVenue: _propTypes2.default.object,
  defaultRoom: _propTypes2.default.object,
  regions: _propTypes2.default.array,
  errors: _propTypes2.default.array.isRequired,
  getVenue: _propTypes2.default.func.isRequired,
  save: _propTypes2.default.func.isRequired,
  saveRoom: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  dates: _propTypes2.default.array,
  search: _propTypes2.default.func.isRequired,
  venue: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = VenueBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/VenueBox.js
// module id = 2227
// module chunks = 0